<template>
  <div
      class="order-return-edit-customer-details flex flex-auto flex-col">
    <div class="title">
      Customer Details
    </div>
    <div style="margin-top: 24px">
      <div class="section-header">
        Customer details
      </div>
    </div>
    <div class="edit-customer-details">
      <div class="flex flex-col gap_s">
        <div class="flex flex-row gap-16">
          <div class="flex-1 input-label">
            First Name
          </div>
          <div class="flex-1 input-label">
            Last Name
          </div>
        </div>
        <div class="flex flex-row gap-16">
          <input
              v-model="editedCustomer.customerFirstName"
              class="flex-1 input-field"
              style="height: 48px;">
          <input
              v-model="editedCustomer.customerLastName"
              class="flex-1 input-field"
              style="height: 48px;">
        </div>
        <div
            v-if="errors.customerFirstName || errors.customerLastName"
            class="flex flex-row gap-16">
          <div
              class="flex-1 input-error">
            {{ errors.customerFirstName }}
          </div>
          <div
              class="flex-1 input-error">
            {{ errors.customerLastName }}
          </div>
        </div>
        <div class="flex flex-row gap-16">
          <div class="flex-1 input-label">
            Email
          </div>
          <div class="flex-1 input-label">
            Phone Number
          </div>
        </div>
        <div class="flex flex-row gap-16">
          <input
              v-model="editedCustomer.customer_email"
              class="flex-1 input-field"
              style="height: 48px;">
          <vue-tel-input
              v-model="editedCustomer.customer_phone"
              :preferred-countries="['US', 'IN', 'AR']"
              mode="international"
              class="flex-1 input-field"
              style="height: 48px;"
              @validate="updatePhoneValidation">
            <i
                slot="arrow-icon"
                class="el-dialog__close el-icon el-icon-arrow-down" />
          </vue-tel-input>
        </div>
        <div
            v-if="errors.customer_email || errors.customer_phone"
            class="flex flex-row gap-16">
          <div
              class="flex-1 input-error">
            {{ errors.customer_email }}
          </div>
          <div
              class="flex-1 input-error">
            {{ errors.customer_phone }}
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 16px">
      <div class="section-header">
        Address
      </div>
    </div>
    <div class="edit-customer-details">
      <div class="flex flex-col gap_s">
        <div class="flex flex-row gap-16">
          <div class="flex-1 input-label">
            Address Line 1
          </div>
        </div>
        <div
            class="flex flex-row gap-16">
          <el-input
              v-model="editedAddress.address_1"
              v-google-places="googleOn"
              class="flex-1 input-field"
              style="padding: 0px;height: 48px;"
              @selected="placeSelected" />
        </div>
        <div class="flex flex-row gap-16">
          <div
              v-if="errors.address_1"
              class="flex-1 input-error">
            {{ errors.address_1 }}
          </div>
        </div>
        <div class="flex flex-row gap-16">
          <div class="flex-1 input-label">
            Address Line 2
          </div>
        </div>
        <div class="flex flex-row gap-16">
          <el-input
              v-model="editedAddress.address_2"
              class="flex-1 input-field"
              style="padding: 0px;height: 48px;" />
        </div>
        <div class="flex flex-row gap-16">
          <div
              v-if="errors.address_2"
              class="flex-1 input-error">
            {{ errors.address_2 }}
          </div>
        </div>
        <div class="flex flex-row gap-16">
          <div class="flex-1 input-label">
            Country
          </div>
          <div class="flex-1 input-label">
            State
          </div>
        </div>
        <div class="flex flex-row gap-16">
          <country-input
              v-model="country_code"
              class="flex-1 select-field"
              :value="country_code"
              @input="emptyState" />
          <country-state-input
              v-model="state_code"
              :input-type="'select'"
              class="flex-1 select-field"
              :country="country_code" />
        </div>
        <div
            v-if="errors.country || errors.state"
            class="flex flex-row gap-16">
          <div
              class="flex-1 input-error">
            {{ errors.country }}
          </div>
          <div
              class="flex-1 input-error">
            {{ errors.state }}
          </div>
        </div>
        <div class="flex flex-row gap-16">
          <div class="flex-1 input-label">
            City
          </div>
          <div class="flex-1 input-label">
            Zip code
          </div>
        </div>
        <div class="flex flex-row gap-16">
          <el-input
              v-model="editedAddress.city"
              class="flex-1 input-field"
              style="padding: 0px;height: 48px" />
          <el-input
              v-model="editedAddress.zip"
              class="flex-1 input-field"
              style="padding: 0px;height: 48px;" />
        </div>
        <div
            v-if="errors.city || errors.zip"
            class="flex flex-row gap-16">
          <div
              class="flex-1 input-error">
            {{ errors.city }}
          </div>
          <div
              class="flex-1 input-error">
            {{ errors.zip }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { cloneDeep } from "lodash";
import CountryStateInput from "@/components/Shared/AddressForm/CountryStateInput.vue";
import CountryInput from "@/components/Shared/AddressForm/CountryInput.vue";
import { createNamespacedHelpers } from "vuex";

const { mapGetters: sharedGetters, mapActions: sharedActions } =
  createNamespacedHelpers("shared");

export default {
  name: "EditCustomerDetails",
  components: { CountryInput, CountryStateInput },
  props: {
    customer: {
      type: Object,
      required: true,
      default() {
        return {
          customer_email: "",
          customer_name: "",
          customer_phone: "",
        };
      },
    },
    address: {
      type: Object,
      required: true,
      default() {
        return {
          address_1: "",
          address_2: "",
          city: "",
          country: "",
          state: "",
          zip: "",
        };
      },
    },
  },
  data() {
    return {
      editedCustomer: {
        customerFirstName: "",
        customerLastName: "",
        customer_email: "",
        customer_phone: "",
      },
      validPhone: true,
      editedAddress: {
        address_1: "",
        address_2: "",
        city: "",
        country: "",
        state: "",
        zip: "",
      },
      country_code: "",
      state_code: "",
      googleOn: true,
    };
  },
  computed: {
    ...sharedGetters(["countries", "countryStates"]),
    errors() {
      return {
        customerFirstName: this.validateFirstName,
        customerLastName: this.validateLastName,
        customer_email: this.validateEmail,
        customer_phone: this.validatePhone,
        address_1: this.validateAddressLine1,
        address_2: this.validateAddressLine2,
        country: this.validateCountry,
        state: this.validateState,
        city: this.validateCity,
        zip: this.validateZip,
      };
    },
    allValid() {
      return !(
        this.validateFirstName ||
        this.validateLastName ||
        this.validateEmail ||
        this.validatePhone ||
        this.validateAddressLine1 ||
        this.validateAddressLine2 ||
        this.validateCountry ||
        this.validateState ||
        this.validateCity ||
        this.validateZip
      );
    },
    validateFirstName() {
      if (
        this.editedCustomer.customerFirstName === "" ||
        this.editedCustomer.customerFirstName === null
      )
        return "First Name is Required";
      return "";
    },
    validateLastName() {
      if (
        this.editedCustomer.customerLastName === "" ||
        this.editedCustomer.customerLastName === null
      )
        return "Last Name is Required";
      return "";
    },
    validateEmail() {
      if (
        this.editedCustomer.customer_email === "" ||
        this.editedCustomer.customer_email === null
      )
        return "Email is Required";
      else if (
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.editedCustomer.customer_email)
      ) {
        return "Invalid Email";
      }
      return "";
    },
    validatePhone() {
      if (
        this.editedCustomer.customer_phone === "" ||
        this.editedCustomer.customer_phone === null
      )
        return "Phone is Required";
      if (!/^[+]{0,1}[0-9 ]+$/.test(this.editedCustomer.customer_phone))
        return "Invalid Phone Number";
      return "";
    },
    validateAddressLine1() {
      if (
        this.editedAddress.address_1 === "" ||
        this.editedAddress.address_1 === null
      )
        return "Address Line 1 is Required";
      return "";
    },
    validateAddressLine2() {
      //Disabling validation for address line 2 as in many addresses this field might not be present
      return "";
    },
    validateCountry() {
      if (this.country_code == null || this.country_code === "")
        return "Please select a country";
      return "";
    },
    validateState() {
      if (this.state_code == null || this.state_code === "")
        return "Please select a State";
      return "";
    },
    validateCity() {
      if (this.editedAddress.city === "" || this.editedAddress.city === null)
        return "City is Required";
      return "";
    },
    validateZip() {
      if (this.editedAddress.zip === "" || this.editedAddress.zip === null)
        return "Zip is Required";
      return "";
    },
  },
  watch: {
    allValid: {
      handler(value) {
        this.$emit("update:allvalid", value);
      },
      immediate: true,
    },
  },
  mounted() {
    // Set incoming address into edited address field so that validations can be applied on edited address
    let name = this.customer.customer_name.split(" ");
    this.customer.customerFirstName = name[0];
    this.customer.customerLastName = this.customer.customer_name.slice(
      name[0].length + 1
    );
  },
  methods: {
    ...sharedActions(["fetchCountries", "fetchCountryStates"]),
    saveChanges() {
      this.editedCustomer.customer_name =
        this.editedCustomer.customerFirstName +
        " " +
        this.editedCustomer.customerLastName;
      this.$emit("update:customer", this.editedCustomer);

      this.editedAddress.country = this.countries[this.country_code].name;
      this.editedAddress.country_code = this.country_code;
      this.editedAddress.state_code = this.state_code;
      let stateList = this.countryStates(this.country_code)[this.state_code];
      this.editedAddress.state = stateList ? stateList.name : this.state_code;
      this.$emit("update:address", this.editedAddress);
      this.$emit("update:edited", true);
    },
    findCountry(countryName) {
      for (const countryCode in this.countries) {
        if (this.countries[countryCode].name === countryName)
          return countryCode;
      }
      return null;
    },
    findState(stateName) {
      let countryStates = this.countryStates(this.country_code);
      for (const stateCode in countryStates) {
        if (countryStates[stateCode].name === stateName) return stateCode;
      }
      return stateName;
    },
    emptyState() {
      console.log("state code ", this.state_code);
      this.state_code = "";
    },
    findStateCode(gPlace) {
      let countryStates = this.countryStates(this.country_code);
      for (const stateCode in countryStates) {
        if (stateCode === gPlace.stateCode) return stateCode;
      }
      return gPlace.state; //When state does not exist in countryStates list, at that time both state code and state name will have same value state name
    },
    updatePhoneValidation(phoneObject) {
      this.validPhone = !!phoneObject.valid;
    },
    placeSelected(gPlace) {
      this.editedAddress.address_1 = gPlace.address1;
      this.editedAddress.address_2 = gPlace.address2;
      this.editedAddress.city = gPlace.city;
      this.editedAddress.zip = gPlace.zip;
      this.editedAddress.state = gPlace.state;
      this.country_code = gPlace.countryCode;
      this.state_code = gPlace.stateCode || this.findStateCode(gPlace);
    },
  },
};
</script>

<style>
.order-return-edit-customer-details {
  gap: 8px;

  .title {
    height: 36px;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    align-self: stretch;
    flex-grow: 0;
  }

  .description {
    height: 24px;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    align-self: stretch;
    flex-grow: 0;
  }

  .section-header {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    color: #424242;
  }

  .edit-customer-details {
    max-width: 544px;
    padding: 0px;
  }

  .gap-16 {
    gap: 16px;
  }

  .input-label {
    height: 18px;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    margin-top: 6px;
    margin-bottom: 4px;
  }

  .input-field,
  .select-field input {
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #81919f;
    border-radius: 4px;

    padding: 12px 16px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #6e6e6e;

    height: unset;
  }

  .input-field:focus,
  .input-field:focus-within {
    border: 2px solid #1998d5 !important;
    box-shadow: none !important;
  }

  .input-error {
    height: 18px;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #d4231a;
  }

  .el-input__inner {
    height: 46px !important;
    padding: 12px 16px;
  }
  .el-switch__label * {
    line-height: 1;
    font-size: 15px;
    font-weight: normal;
    display: inline-block;
  }
}
</style>
